import { getLeFEOrigin } from '@utils/util';

export const LbgWaterlineLeFE = () => (
    <iframe className="admin-iframe" title="LBG 水位线管理" src={`${getLeFEOrigin()}/#/app/admin/waterline`} />
);
